import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Beat } from "../../../plugins/spinners.plugin";
import { Dialog, Transition } from "@headlessui/react";
import Button from "../../buttons/buttons";
import Input from "../../inputs/inputs";
import { RiCloseLine } from "react-icons/ri";
import {
  createThirdPartyWebhook,
  getMyThirdPartyWebhooks,
} from "../../../redux/thirdPartyWebhook/thirdPartyWebhookActions";
import { getTeamFromCookies } from "../../../utils/Auth";

export default function CreateWebhookModal(props) {
  const dispatch = useDispatch();
  const team = getTeamFromCookies();

  const [submitted, setSubmitted] = useState(false);
  const [data, setData] = useState({
    business_id: team,
    label: "",
    url: "",
    events_allowed: [],
  });
  const { label, url, events_allowed } = data;
  const { creating } = useSelector((state) => state.thirdParty);

  const eventOptions = [
    { name: "Order created", value: "order.created" },
    { name: "Order updated", value: "order.updated" },
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  const handleCheckboxChange = (event) => {
    const updated = events_allowed.includes(event)
      ? events_allowed.filter((e) => e !== event)
      : [...events_allowed, event];
    setData({ ...data, events_allowed: updated });
  };

  const handleSubmit = async () => {
    setSubmitted(true);
    if (label && team && url && events_allowed?.length > 0) {
      try {
        const response = await dispatch(createThirdPartyWebhook(data));
        if (response) {
          dispatch(getMyThirdPartyWebhooks(team));
          props.onClose();
        }
      } catch (error) {
        console.log("error", error);
      }
    }
  };
  return (
    <>
      <Transition appear show={props.show}>
        <Dialog as="div" className="relative z-10" onClose={props.onClose}>
          <Transition.Child
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed z-10 inset-0 overflow-y-auto">
            <div className="flex items-center sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
              <Transition.Child
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="bg-white dark:bg-[#121212] max-w-[450px] w-full sm:rounded-md rounded-sm sm:w-[450px] p-4 sm:p-6 ">
                  <div>
                    <div className="hidden sm:block absolute top-3 right-2 pt-4 pr-4">
                      <button
                        type="button"
                        className=" "
                        onClick={props.onClose}
                      >
                        <span className="sr-only">Close</span>
                        <RiCloseLine />
                      </button>
                    </div>
                    <div className="">
                      <div className=" text-center sm:text-left ">
                        <Dialog.Title
                          as="h3"
                          className="text-base font-medium text-black dark:text-white"
                        >
                          Create a third party web hook
                        </Dialog.Title>
                      </div>
                    </div>
                    <div className=" border-b-2 mt-4"></div>
                    <div className="mt-5 sm:mt-7 text-left">
                      <form>
                        <div>
                          <Input.Label
                            title={"Label/Name"}
                            htmlFor={"label"}
                            name={"label"}
                            onChange={handleChange}
                            value={label}
                            placeholder={"Enter token label/name"}
                          />
                          {submitted && !label && (
                            <div className="text-xs text-red-500">
                              Label is required
                            </div>
                          )}
                        </div>
                        <div>
                          <Input.Label
                            title={"Url"}
                            htmlFor={"url"}
                            name={"url"}
                            onChange={handleChange}
                            value={url}
                            placeholder={"Enter token url"}
                          />
                          {submitted && !url && (
                            <div className="text-xs text-red-500">
                              Url is required
                            </div>
                          )}
                        </div>
                        <div className="mt-8">
                          {/* <label className="text-sm font-medium text-gray-700 dark:text-gray-300">
                            Events Allowed
                          </label> */}
                          <div className="mt-2 grid grid-cols-2 gap-6">
                            {eventOptions.map((event) => (
                              <label
                                key={event.value}
                                className="flex items-center gap-2 cursor-pointer"
                              >
                                <input
                                  type="checkbox"
                                  checked={events_allowed.includes(event.value)}
                                  onChange={() =>
                                    handleCheckboxChange(event.value)
                                  }
                                  className="h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary"
                                />
                                <span className="text-base text-gray-700 dark:text-gray-300">
                                  {event.name}
                                </span>
                              </label>
                            ))}
                          </div>
                          {submitted && events_allowed.length === 0 && (
                            <div className="text-xs text-red-500 mt-1">
                              At least one event is required
                            </div>
                          )}
                        </div>
                      </form>
                    </div>
                    <div className="flex justify-between mt-14 sm:mt-24">
                      <Button.Secondary
                        title={"Back"}
                        className={"rounded-md px-4"}
                        onClick={props.onClose}
                      />
                      <Button.Primary
                        title={creating ? <Beat /> : "Create Webhook"}
                        className={"rounded-md px-4"}
                        type="button"
                        onClick={handleSubmit}
                      />
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
